import qs from "qs";
import { api } from "@data-phone/react-resource-server-auth";
import { Utils } from "utils";

export const fetchIntegrationLookup = async (
  integrationName: string,
  number: string | string[]
): Promise<any[]> => {
  try {
    const numbers = Array.isArray(number) ? number : [number];

    const query = `?${qs.stringify({ numbers })}`;
    
    const response = await api.get(
      `${process.env.REACT_APP_API_BASE_URL}/integrations/${integrationName}/lookup${query}`
    );

    const data = response?.data

    const now = Date.now();

    const results = Object.entries(data || {}).map(([numKey, item]: [string, any | null]) => {
      if (item && typeof item === "object") {
        return {
          ...item,
          _cachedAt: now,
        };
      }

      const normalizedNumber = Utils.phoneNumberFormatE164(numKey);

      return {
        _cachedAt: now,
        _empty: true,
        HomePhone: normalizedNumber,
      };
    });

    return results;
  } catch (error: any) {
    console.error(`❌ ${integrationName} Lookup Failed:`, error);
    throw new Error(error?.message || "Lookup failed");
  }
};

